import { render, staticRenderFns } from "./product_npbkcd4.vue?vue&type=template&id=6c01c570&scoped=true"
import script from "./product_npbkcd4.vue?vue&type=script&lang=js"
export * from "./product_npbkcd4.vue?vue&type=script&lang=js"
import style1 from "./product_npbkcd4.vue?vue&type=style&index=1&id=6c01c570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01c570",
  null
  
)

export default component.exports